/** After the user clears chips, do not copy a stale store selection back into the widget. */
export function shouldHoldMultiSelectUserClear(
  userClearedLive: boolean,
  storeItemCount: number,
): boolean {
  return userClearedLive === true && storeItemCount > 0
}

/** Swing `JJMultiSelect.removeItem` when linked: drop the item and every item after it. */
export function sliceLinkedMultiSelectItems<T>(items: T[], removedIndex: number): T[] {
  if (!Array.isArray(items) || removedIndex < 0) return items
  return items.slice(0, removedIndex)
}

/** Server suggest is the only dropdown source (Swing getAutoCompleteList). Selected rows are not options. */
export function resolveMultiSelectSuggestOptions<T>(opts: {
  serverRows: T[]
  staticRows: T[]
  hasServerFetcher: boolean
}): T[] {
  if (opts.hasServerFetcher) return Array.isArray(opts.serverRows) ? opts.serverRows : []
  return Array.isArray(opts.staticRows) ? opts.staticRows : []
}
